import React, { Component } from "react";
import { connect } from "react-redux";
import {
  openEditerAction,
  showInputTempWindowAction,
  showDetailEditerWindowAction,
} from "../redux/ui/actions";
import { changeDsAction, changeNewDsAction } from "../redux/boring/actions";
import {
  changeBoringID1Action,
  changeBoringID2Action,
  changeWlsYListEAction,
  changeWlsTListAction,
  changeWlsYScaleEAction,
  changeWlsBListEAction,
  changeSelRowAction,
  changeDataAction,
  regEditerAction,
  changeDetailCatAction,
} from "../redux/editer/actions";
import Sw from "./common/Sw";
import InputTemp from "./linkGM/InputTemp";
import Detail from "./editer/Detail";

const mapStateToProps = (state) => {
  return {
    editerSw: state.uiReducer.editerSw,
    geoDs: state.geoReducer.dataset,
    boringDs: state.boringReducer.dataset,
    newDs: state.boringReducer.newDs,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    wlsYScale: state.editerReducer.wlsYScale,
    wlsTList: state.editerReducer.wlsTList,
    wlsYList: state.editerReducer.wlsYList,
    wlsBList: state.editerReducer.wlsBList,
    isReg: state.editerReducer.isReg,
    selRow: state.editerReducer.selRow,
    isChange: state.editerReducer.isChange,
    regNum: state.boringReducer.regNum,
    estBorSw: state.uiReducer.estBorSw,
    wellsTrData: state.boringReducer.wellsTrData,
    inputTenpWindowVisible: state.uiReducer.inputTenpWindowVisible,
    checkPreInd: state.boringReducer.checkPreInd,
    detailEditerWindowVisible: state.uiReducer.detailEditerWindowVisible,
    detailCat: state.editerReducer.detailCat,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);

    this.scaleWidth = 15; //1目盛 = 15px
    this.maxY = null;
    this.wlsYScale = null;
    this.thkList = [];
    this.wlsYList = [];
    this.boring = null;
    this.boringID1 = this.props.checkPreInd;
    this.sameCoordID = null;

    this.createEditer = this.createEditer.bind(this);
    this.createDiag = this.createDiag.bind(this);
    this.changeYScale = this.changeYScale.bind(this);
    this.changeRow = this.changeRow.bind(this);
    this.changeInputTempVisible = this.changeInputTempVisible.bind(this);
    this.tbRef = React.createRef();
    this.$hoverCell = null;

    this.props.dispatch(changeSelRowAction(null));
    this.createEditer(this.boringID1);
    this.state = {
      isCellClicked: false,
    };
    //this.screenInvisible();
  }

  componentDidUpdate(prevProps) {
    /*
     * 選択ボーリング変更
     * @since hara 2020-09-09
     */
    if (prevProps.checkPreInd !== this.props.checkPreInd) {
      //行選択解除
      this.tbRef.childNodes.forEach((el) => {
        el.classList.remove("selRow");
      });
      this.props.dispatch(changeSelRowAction(null));

      this.boringID1 = this.props.checkPreInd;

      this.createEditer(this.boringID1);
    }

    /*
     * エディタ更新
     * @since hara 2020-09-09
     */
    if (prevProps.newDs !== this.props.newDs && this.props.isChange) {
      //初期と入力値変更時
      if (this.boring !== null && !this.boring.geo.length)
        //geoが空の場合、行選択解除
        this.props.dispatch(changeSelRowAction(null));

      this.props.dispatch(changeDataAction(false));
      this.createEditer(this.boringID1);
    }
  }

  /*
   * エディタ作成
   * @param {String} ID1 ボーリングID1
   * @param {String} ID2 ボーリングID2
   * @param {String} selVal 選択された値(初期表示の場合はnull)
   * @since hara 2020-09-09
   */
  createEditer(ID1) {
    //this.boring = this.props.newDs[ID1].data[ID2];
    this.boring = this.props.wellsTrData[ID1].PREDATA;
    this.sameCoordID = [];
    const ds = [...this.props.newDs];

    this.createTable();
    this.createDiag(true);
  }

  /*
   * テーブル作成
   * @since hara 2020-10-07
   */
  createTable() {
    this.thkList = [];
    let wlsTList = [];
    let preDepThk = 0;

    if (this.boring.geo.length) {
      //geoが空でない場合
      this.boring.geo.forEach((el, index) => {
        const sel = this.props.geoDs[0].geo[el[1] - 1]; //現在は13分類のみ
        let depTd;
        let thkTd;
        let scrTd;
        let thk;

        thk = el[0] - preDepThk;
        //depTd = <input className='textT l-textR' value={(el[0]).toFixed(2)} onChange={e => this.changeField(index, 0, e)} />;/*★公開版で削除 下のコメント解除*/
        depTd = <p className="l-textR">{el[0].toFixed(2)}</p>;
        thkTd = <p className="l-textR">{Math.abs(thk).toFixed(2)}</p>;

        preDepThk = el[0];

        scrTd = this.boring.screen[index][0];

        let test = false;
        if (scrTd) {
          test = true;
        }

        this.thkList.push([thk, el[1], this.boring.screen[index]]);
        wlsTList.push(
          <tr id={index} key={index} onClick={this.changeRow}>
            <td>{sel.ID}</td>
            <td>
              {/*★ここから公開版で削除*/}
              {/*
                            <select className='selectT' value={sel.ID} onChange={e => this.changeField(index, 1,  e)}>
                                {this.props.geoDs[0].geo.map(el => (
                                    <option value={el.ID} key={el.ID}>{el.name}</option>
                                ))}
                            </select>
                            */}
              {/*★ここまで公開版で削除 下のコメント解除*/}
              <p>{this.props.geoDs[0].geo[sel.ID - 1].name}</p>
            </td>
            <td style={{ backgroundColor: sel.color }}></td>
            <td>{depTd}</td>
            <td>{thkTd}</td>
            <td className="scrCheck">
              <input
                type="checkbox"
                id={"scr" + index}
                name={index}
                value={index}
                onChange={(e) => this.hglCell(e, index)}
                checked={scrTd}
              />
            </td>
          </tr>
        );
      });
    }
    this.props.dispatch(changeWlsTListAction(wlsTList));
  }

  /*
   * セルハイライト
   * @param {Event} e イベント情報
   * @param {String} num IDの番号
   * @since hara 2021-02-25
   */
  hglCell(e, num) {
    //console.log(e)
    if (e === null) {
      //leave時、ハイライト解除
      if (this.$hoverCell !== null)
        this.$hoverCell.classList.remove("cellClick");
      this.$hoverCell = null; // ハイライト解除時に$hoverCellをクリア
    } else {
      //mouseover時、ハイライト
      this.$hoverCell = document.getElementById("boringEdiCell_" + num);
      if (this.$hoverCell.classList.contains("cellClick")) {
        this.$hoverCell.classList.remove("cellClick");
        this.boring.screen[num][0] = false;
      } else {
        this.$hoverCell.classList.add("cellClick");
        this.boring.screen[num][0] = true;
        document.getElementById("scr" + num).checked = true;
      }
    }
    this.createTable();
  }
  /*
   * 図作成
   * @param {Boolean} isInit true=初期値による表示/false=入力値による表示
   * @since hara 2020-09-09
   */
  createDiag(isInit) {
    this.wlsYList = [];
    let wlsBList = null;

    if (this.boring.geo.length) {
      //geoが空でない場合
      this.setScale(isInit);

      const createBoring = () => {
        let li = [];
        this.thkList.forEach((el, index) => {
          li.push(
            <li
              style={{
                backgroundColor: this.props.geoDs[0].geo[el[1] - 1].color,
                height: (el[0] * this.scaleWidth) / this.wlsYScale + "px",
              }}
              key={`boringEdiCell_${index}_${Math.random().toString(36).substr(2, 9)}`}
              id={`boringEdiCell_${index}`}
              className={el[2][0] === true ? "cellClick" : null}
            >
              <div
                className="Boring__wl"
                style={{
                  top: (el[0] * this.scaleWidth) / this.wlsYScale + "px",
                }}
              ></div>
            </li>
          );
        });
        return li;
      };

      const drawWl = this.boring.GL - this.boring.WL;
      //地下水位取得
      const getWl = () => {
        if (
          drawWl <= this.maxY &&
          this.boring.WL !== undefined &&
          this.boring.WL !== null
        ) {
          let top = (drawWl * this.scaleWidth) / this.wlsYScale;
          //2 = borderの太さ（border-bottom4px）の半分2px
          top = top - 2;
          return (
            <li className="EditerLgd__wl" style={{ top: top + "px" }}></li>
          );
        } else {
          return null;
        }
      };
      wlsBList = (
        <ul className="EditerLgd__main">
          {createBoring()}
          {getWl()}
        </ul>
      );

      this.createScale(this.wlsYScale, this.maxY);
    }

    this.props.dispatch(changeWlsYScaleEAction(this.wlsYScale));
    this.props.dispatch(changeWlsYListEAction(this.wlsYList));
    this.props.dispatch(changeWlsBListEAction(wlsBList));
  }

  /*
   * 目盛設定
   * @param {Boolean} isInit true=初期値による表示/false=入力値による表示
   * @since hara 2020-09-09
   */
  setScale(isInit) {
    /*
     * Y軸目盛最大値計算
     * return {Boolean} this.maxY Y軸目盛最大値
     * @since hara 2020-09-09
     */
    const calcMaxY = () => {
      this.maxY = 0;
      this.thkList.forEach((el) => {
        this.maxY += el[0];
      });

      return this.maxY;
    };

    if (isInit) {
      //最初は自動で目盛設定
      const root = 16; //rootのフォントサイズ(商用版ではディスプレイサイズによって可変とする)
      const dspH = (24 - 1.2) * root; //24=height24 1.2=padding0.6
      let YScaleNum = Math.floor(dspH / this.scaleWidth);
      this.wlsYScale = Math.ceil((calcMaxY() / YScaleNum) * 10) / 10;
      if (this.wlsYScale < 0.5) {
        //目盛が0.5以下の場合
        this.wlsYScale = 0.5;
      }
    } else {
      //入力値の確認
      if (0.5 <= this.props.wlsYScale) {
        this.wlsYScale = this.props.wlsYScale;
      }
    }
  }

  /*
   * 目盛作成
   * @param {Number} scale 1目盛値
   * @param {Boolean} max 目盛最大値
   * @since hara 2020-09-09
   */
  createScale(scale, max) {
    const num = Math.ceil(max / scale);
    for (let i = 1; i <= num; i++) {
      this.wlsYList.push(
        <li className="scaleY--editer" key={i}>
          {(scale * i).toFixed(window.getDecDig(scale))}
        </li>
      );
    }
  }

  /*
   * 標尺(Y軸)入力変更
   * @param {Event} e イベント情報
   * @since hara 2020-09-09
   */
  changeYScale(e) {
    this.props.dispatch(changeWlsYScaleEAction(e.target.value));
  }

  /*
   * テーブル選択
   * @param {Event} e イベント情報
   * @since hara 2020-10-08
   */
  changeRow(e) {
    e.target.closest("tbody").childNodes.forEach((el) => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");

    this.props.dispatch(changeSelRowAction(parseInt(tr.id)));
  }
  /*
   * 入熱温度入力テーブル表示
   * @param {Event} e イベント情報
   * @since ando 2024-1-29
   */
  changeInputTempVisible() {
    if (this.props.inputTenpWindowVisible) {
      this.props.dispatch(showInputTempWindowAction(false));
      return this.props.dispatch(showInputTempWindowAction(false));
    } else {
      return this.props.dispatch(showInputTempWindowAction(true));
    }
  }

  /*
   * スクリーン位置列表示非表示
   * @since ando 2023-08-25
   */
  screenInvisible() {
    let tbl = document.getElementById("testTbl");
    tbl.style.display = "none";
  }

  /*
   * 計測データウィンドウを開く
   * @since ando 2024-12-05
   */
  openMeaDataSw(cat) {
    if (cat == 2) {
      this.props.dispatch(changeDetailCatAction(1));
      if (this.props.detailEditerWindowVisible) {
        this.props.dispatch(showDetailEditerWindowAction(false));
        this.props.dispatch(showDetailEditerWindowAction(true));
      } else {
        this.props.dispatch(showDetailEditerWindowAction(true));
      }
    }
  }

  render() {
    return (
      <div className={window.getBorsCaptFlag() ? "hidden-window" : undefined}>
        <Sw title="予測ボーリング" focusName="estBor">
          <div className="Editer_wrap l-flex">
            <div>
              <div
                className={
                  1 < this.sameCoordID.length ? "l-row l-mtS" : "l-row"
                }
              >
                <label>名称：</label>
                <div
                  className="color2"
                  style={{
                    backgroundColor: this.boring.color,
                  }}
                ></div>
                <p>{this.boring.name}</p>
                <label className="l-blank">ID：</label>
                <p>{this.boring.ido_ID}</p>
              </div>

              <div className="l-row l-mtS">
                <label>緯度：</label>
                <p>{this.boring.lat.toFixed(5)}</p>
                <label className="l-blank">経度：</label>
                <p>{this.boring.lon.toFixed(5)}</p>
                <label className="l-blank">孔口標高：</label>
                <p>
                  {this.boring.GL === undefined || this.boring.GL === null
                    ? "-"
                    : this.boring.GL.toFixed(1)}
                </p>
                <label className="l-blank">地下水標高：</label>
                <p>
                  {this.boring.WL === undefined || this.boring.WL === null
                    ? "-"
                    : this.boring.WL.toFixed(1)}
                </p>
                <label className="l-blank">
                  <button
                    className="sBtn"
                    onClick={() => this.openMeaDataSw(2)}
                  >
                    詳細情報
                  </button>
                </label>
                {this.props.wellsTrData[this.props.checkPreInd].KIND ==
                  "type2" && (
                  <>
                    <label className="l-blank">
                      <button
                        className="sBtn"
                        onClick={(e) => this.changeInputTempVisible(e)}
                      >
                        入熱温度
                      </button>
                    </label>
                  </>
                )}
              </div>

              <fieldset className="Unit l-mtS">
                <div className="btnWrap">
                  <label>標尺 (Y軸)：</label>
                  <input
                    className="textS"
                    type="text"
                    value={this.props.wlsYScale}
                    onChange={this.changeYScale}
                  />
                  <button
                    className="sBtn l-mlS"
                    onClick={() => this.createDiag(false)}
                  >
                    適用
                  </button>
                  <button
                    className="sBtn l-mlS"
                    onClick={() => this.createDiag(true)}
                  >
                    初期値
                  </button>
                </div>

                <div className="l-flex l-mtS">
                  <div className="EditerTWrap" style={{ overflowY: "scroll" }}>
                    <table className="table" id="testTbl">
                      <thead>
                        <tr>
                          <th>地質ID</th>
                          <th className="tsM">地質名称</th>
                          <th>地質カラー</th>
                          <th>深度</th>
                          <th>層厚</th>
                          <th>スクリーン</th>
                        </tr>
                      </thead>
                      <tbody ref={(ref) => (this.tbRef = ref)}>
                        {this.props.wlsTList}
                      </tbody>
                    </table>
                  </div>
                  <div className="EditerLgd l-mlM">
                    <ul className="EditerLgd__y">{this.props.wlsYList}</ul>
                    {this.props.wlsBList}
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </Sw>
        {this.props.inputTenpWindowVisible ? <InputTemp /> : null}
        {this.props.detailEditerWindowVisible && this.props.detailCat == 1 ? (
          <Detail />
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
